export const route = 'getHourlyForecast';

export const layoutConfig = {
  '1x1': {
    visibleCount: ({ compact1x1VisibleCount }) => compact1x1VisibleCount,
    selectorMode: 'row',
    selectorHeight: 'clamp(4.25rem, 46%, 4.75rem)',
    selectorGap: 6,
    selectorTileStyle: { padding: '0.25rem 0.35rem' },
    compactTimeUpdate: true,
    wrapperClassName: 'd-flex flex-column w-100 h-100 overflow-hidden',
    contentOuterStyle: { flex: '1 1 0', minHeight: 0, width: '100%' },
    contentClassName: 'w-100 h-100 d-flex flex-column justify-content-start p-1 my-0',
    contentStyle: { flex: '1 1 0', minHeight: 0 },
    detailsClassName: 'mt-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 2),
    }),
    detailsIconSize: 14,
    detailGroups: [
      ['temperature', 'comfort', 'dewPoint'],
      ['windSpeed', 'windDirection'],
      ['humidity', 'visibility', 'precipitationProbability'],
    ],
  },
  '1x2': {
    visibleCount: ({ compact1x2ColumnCount }) => compact1x2ColumnCount * 2,
    selectorMode: 'grid',
    selectorHeight: 'clamp(8.5rem, 50%, 13rem)',
    selectorGap: 6,
    selectorTileStyle: { padding: '0.45rem' },
    compactTimeUpdate: false,
    wrapperClassName:
      'd-flex flex-column flex-grow-1 h-100 align-content-center justify-content-center overflow-hidden',
    contentOuterStyle: { flex: '1 1 0', minHeight: 0, width: '100%' },
    contentClassName: 'd-flex w-100 h-100 align-items-center flex-column pt-2',
    contentStyle: { flex: '1 1 0', minHeight: 0 },
    detailsClassName: 'mt-3 px-2',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 1),
    }),
    detailsIconSize: 18,
    detailGroups: [
      [
        'temperature',
        'comfort',
        'dewPoint',
        'windSpeed',
        'windDirection',
        'humidity',
        'visibility',
        'precipitationProbability',
      ],
    ],
  },
  '2x1': {
    visibleCount: () => 7,
    selectorMode: 'row',
    selectorHeight: 'clamp(4.75rem, 48%, 6.75rem)',
    selectorGap: 8,
    selectorTileStyle: { padding: '0.45rem' },
    compactTimeUpdate: false,
    wrapperClassName:
      'd-flex flex-column flex-grow-1 h-100 align-content-center justify-content-center overflow-hidden',
    contentOuterStyle: { flex: '1 1 0', minHeight: 0, width: '100%' },
    contentClassName: 'w-100 h-100 d-flex flex-column justify-content-start px-2 py-2',
    contentStyle: { flex: '1 1 0', minHeight: 0 },
    detailsClassName: 'mt-2 px-2',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 1),
    }),
    detailsIconSize: 18,
    detailGroups: [
      ['temperature', 'comfort', 'dewPoint'],
      ['windSpeed', 'windDirection'],
      ['humidity', 'visibility', 'precipitationProbability'],
    ],
  },
};
